"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberFormatterOrderAnalytic = void 0;
const React = require("react");
const react_1 = require("react");
class NumberFormatterOrderAnalytic extends react_1.Component {
    render() {
        const value = Number(this.props.value);
        let text = value.toLocaleString(undefined, {
            style: "currency",
            currency: "USD"
        });
        if (text === "$NaN" || !value) {
            text = "";
        }
        return React.createElement("span", null, text);
    }
}
exports.NumberFormatterOrderAnalytic = NumberFormatterOrderAnalytic;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/claim-analytics/number-formatter-order-analytic.tsx
// module id = 3928
// module chunks = 0